/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:17:40
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2025-09-16 19:21:34
 * @FilePath: \app-client-h5\src\pages\rechargeResult\index.jsx
 */
import React, { Component } from 'react';
import {
   
    Button,
    Selector,
    Space,
    List,
} from 'antd-mobile';
import {getQueryVariable,host} from '../../utils/util'
import './index.scss'
class RechargeResult extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            okIcon: require('../../assets/ok.png'),

        }
    }

    componentWillUnmount() {

    }
    componentDidMount() {
        document.title = '支付完成'
    }
    goHome = ()=>{
        let data = {telphone: window.sessionStorage.getItem('telphone')}
        // this.props.history.replace('/home?data='+JSON.stringify(data))
        this.props.history.go(-2);
    }
    checkOrder = ()=>{
        let orderNo = getQueryVariable('orderNo')
        this.props.history.push('/orderDetail?orderNo='+orderNo)
    }
    render() {
        const {okIcon} =this.state;
        return (
            <div className='result-container'>
                <div>
                    <img className = 'okIcon' src = {okIcon} />
                </div>
                <div className = 'ok'>支付成功</div>
                {/* <div className = 'text'>购买的水量将会在水表下一次更新数据执行到水表里</div>
                <div className = 'btn-box'>
                    <Button className = 'gohome-btn' fill='outline'  shape='rounded' color='primary' onClick={this.goHome}>返回首页</Button>
                    <Button className = 'check-btn' shape='rounded' color='' onClick={this.checkOrder}>查看订单</Button>
                </div> */}
            </div>


        )
    }
}
export default RechargeResult;

